<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Andrew grew up in rural Hawkes Bay on an orchard and his interest in music took him to Wellington where he lived for twelve years as a musician. He moved back to the family property to look after his mother in her later years and a publishing deal with Ford NZ for one of his songs allowed a year off work and the writing of Wester Island. This time included travel to Egypt and some of the book was written there.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?1ca53d53